import { render } from "./Collections.vue?vue&type=template&id=adc3ddd0&scoped=true"
import script from "./Collections.vue?vue&type=script&lang=js"
export * from "./Collections.vue?vue&type=script&lang=js"

import "./Collections.vue?vue&type=style&index=0&id=adc3ddd0&scoped=true&lang=css"
import "./Collections.vue?vue&type=style&index=1&id=adc3ddd0&lang=css"
import "./Collections.vue?vue&type=style&index=2&id=adc3ddd0&scoped=true&lang=css"
import "./Collections.vue?vue&type=style&index=3&id=adc3ddd0&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adc3ddd0"]])

export default __exports__